export const urls = {
  developmentUrl: 'https://bookings.olpejetaconservancy.org'
}
